import type { ReactElement } from "react";

import { cn } from "~/lib/cn";

interface AuthFormErrorProps {
  message: string | null | undefined;
  className?: string;
}

export function AuthFormError({
  message,
  className,
}: AuthFormErrorProps): ReactElement | null {
  if (!message) return null;

  return (
    <div
      className={cn(
        "rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700",
        className,
      )}
    >
      {message}
    </div>
  );
}
